import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpBackend from 'i18next-http-backend'

export const SUPPORTED_LOCALES = ['en', 'fr', 'de'] as const
export type SupportedLocale = typeof SUPPORTED_LOCALES[number]

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [...SUPPORTED_LOCALES],
    fallbackLng: 'en',
    ns: ['common', 'home', 'services', 'pricing', 'contact', 'auth', 'seo', 'about', 'projects'],
    defaultNS: 'common',
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json' },
    detection: { order: ['path', 'navigator'], lookupFromPathIndex: 0, caches: ['localStorage'] },
    interpolation: { escapeValue: false },
    react: { useSuspense: true }
  })

export default i18n
